(function (w) {
    function CountryFlagsDropdownViewModel(countrySelectId, countryIdObservable, ukFlagUrl, filterTextObservable) {
        var self = this;

        //#region Opening and closing the dropdown:

        self.IsDropdownOpen = ko.observable(false);

        self.OpenDropdown = function () {
            self.IsDropdownOpen(true);
            filterTextObservable('');
            $(".flag-dropdown-filter").focus();
        };

        self.CloseDropdown = function () {
            self.IsDropdownOpen(false);
        };

        // close dropdowns when clicked elsewhere on the page
        $(document).on('touchstart click', function (event) {
            if (!$(event.target).parents().is('.flag-wrapper')) {
                self.CloseDropdown();
            }
        });
        $(document).on('keydown', function (event) {
            if (event.key === "Escape" && $(event.target).parents().is('.flag-wrapper')) {
                self.CloseDropdown();
            }
            if (event.keyCode === 13 && $(event.target).parents().is('.flag-wrapper')) {
                self.CloseDropdown();
            }
        });

        //#endregion

        //#region Creating and clicking countries

        self.Countries = ko.observableArray([]);

        // Creating the array of countries based on another (hidden) select's options
        // Note: some data attributes are required on the options (countrycode, countrynames, countryid)
        $("#" + countrySelectId + " option").each(function () {
            var countryId = $(this).data('countryid');
            if (countryId) {
                self.Countries.push({
                    countryId: countryId,
                    code: $(this).data('countrycode'),
                    countryNames: $(this).data('countrynames'),
                    text: $(this).text(),
                    imageSrc: ukFlagUrl.replace(/[A-Za-z]{2}-flag/i, $(this).data('countrycode') + "-flag")
                });
            }
        });

        self.ListeningForCountryChange = true;
        self.SelectCountry = function (country) {

            self.ListeningForCountryChange = false;
            countryIdObservable(country.countryId);
            self.CloseDropdown();
            $('.selected-flag-img').attr('src', country.imageSrc);
            self.ListeningForCountryChange = true;
        };

        // if something else changes country (e.g. default setting or another dropdown) then change the flag for this country
        countryIdObservable.subscribe(function (countryId) {
            if (self.ListeningForCountryChange) {
                var countries = self.Countries();
                if (countries && countries.length) {
                    for (var i = 0; i < countries.length; i++) {
                        var selectedCountry = countries[i];
                        if (selectedCountry.countryId == countryId) {
                            $('.selected-flag-img').attr('src', selectedCountry.imageSrc);
                            return;
                        }
                    }
                }
            }
        });

        //#endregion

        //#region Filtering the list of countries
        self.FilteredCountries = ko.observableArray(self.Countries());

        filterTextObservable.subscribe(function (val) {
            if (!val) {
                self.FilteredCountries(self.Countries());
            }

            var filterText = val.toLowerCase();

            var filteredCountries = [];
            var countries = self.Countries();
            if (!countries || !countries.length)
                return;

            for (var i = 0; i < countries.length; i++) {
                var country = countries[i];
                if (country.countryNames.toLowerCase().indexOf(filterText) > -1) {
                    filteredCountries.push(country);
                }
            }

            self.FilteredCountries(filteredCountries);
        });
        //#endregion
    }
    w.countryFlagsDropdownViewModel = CountryFlagsDropdownViewModel;
})(window);